import React from 'react';
import { logout } from '../api'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavLink,
  NavItem } from 'reactstrap';
import { withRouter } from 'react-router-dom';

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    console.log('navbar constructor', window.localStorage, window.localStorage.getItem('token'))

    this.toggle = this.toggle.bind(this);
    this.logout = this.logout.bind(this);
    this.state = {
      isOpen: false,
      isLogged: window.localStorage.getItem('token')
    };
  }

  logout() {
    console.log('logging out')
    logout().then(() => {
      console.log('logout')
      window.localStorage.removeItem('username')
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('token_expires')
      this.props.history.push('/login')
    }).catch(err => {
      console.log('logout failed', err)
    })
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    console.log('perkele', this.state)
    return (
      <div>
        <Navbar color="dark" dark expand="md">
          <NavbarBrand href="/">journal<sup>-3 2.0</sup></NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar>
              <NavItem>
                <NavLink href="/">Entries</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/measurements">Measurements</NavLink>
              </NavItem>
            </Nav>
            <Nav className="ml-auto" navbar>
              <NavItem>
                {!this.state.isLogged &&
                  <NavLink href="/login">Login</NavLink>
                }
                {this.state.isLogged &&
                  <NavLink onClick={this.logout} href="#">Logout</NavLink>
                }
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default withRouter(NavBar)
